import React, { useEffect, useState } from 'react';
import '../../App.css';
import './user-control.css';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../app/hooks';

// types
import { UserType } from '../../utils/types';

// classes
import { HideDropdownMenu } from '../../utils/functions';

// images
import { KeyRound, UserRound, Settings2, LogOut } from 'lucide-react';

//	--------------------------------------------------------------------------
//
//	R E D U X   S T A T E   M A N A G E M E N T
//
//	--------------------------------------------------------------------------

import { setUserDropdownMenuDisplayed } from '../../app-slice';

//	--------------------------------------------------------------------------
//
//	P R O P E R T I E S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	H T M L   C U S T O M   C O M P O N E N T S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	C L A S S   D E F I N I T I O N
//
//	--------------------------------------------------------------------------

export default function UserControlDropdownMenu(props: { buttonHandler: any }) {
  //
  //	--------------------------------------------------------------------------
  //
  //	R E D U X   S T A T E   H A N D L I N G
  //
  //	--------------------------------------------------------------------------

  // global state variables.
  const sG_userType: UserType = useAppSelector(
    (state) => state.global.userType ?? UserType.STANDARD,
  );

  // app state variables.
  const sUserDropdownMenuDisplayed: boolean = useAppSelector(
    (state) => state.app.userDropdownMenuDisplayed,
  );

  //	--------------------------------------------------------------------------
  //
  //	D E C L A R A T I O N S
  //
  //	--------------------------------------------------------------------------

  // multi-language support
  const { i18n, t } = useTranslation();

  // function that monitors for mouse clicks. we need to add {ref} to the DIV element of the dropdown menu.
  const { ref } = HideDropdownMenu({
    sDropdownDisplayed: sUserDropdownMenuDisplayed,
    setDropdownDisplayed: setUserDropdownMenuDisplayed,
  });

  const [sDropdownMaxHeight, setDropdownMaxHeight] = useState<string>('80dvh');

  //	------------------------------------------------------------
  //
  //	A HTML component that renders a single menu item on the
  //	dropdown menu.
  //
  //	------------------------------------------------------------

  function MenuItem(args: { name: string; text: string; Icon?: any; onClick: any }) {
    return (
      <button name={args.name} className="menu-button text-colour" onClick={args.onClick}>
        <span className="menu-button-text"> {args.text} </span>
        {args.Icon !== undefined && (
          <args.Icon width={24} height={24} strokeWidth={1.5} />
        )}
      </button>
    );
  } // MenuItem

  //	------------------------------------------------------------
  //
  //	H O O K S
  //
  //	------------------------------------------------------------

  // Keep the dropdown inside the viewport: measure its actual top position and
  // clamp max-height to the remaining space below it.
  useEffect(() => {
    //
    const updateHeight = () => {
      if (!ref.current || !sUserDropdownMenuDisplayed) return;
      const top = ref.current.getBoundingClientRect().top;
      setDropdownMaxHeight(`${Math.max(100, window.innerHeight - top - 16)}px`);
    };

    requestAnimationFrame(updateHeight);
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
    //
  }, [sUserDropdownMenuDisplayed]);

  //	------------------------------------------------------------
  //
  //	C O M P O N E N T   C O D E
  //
  //	------------------------------------------------------------

  return (
    <div
      ref={ref}
      role="navigation"
      aria-label="User links"
      className="user-dropdown-menu"
      style={{
        maxHeight: sDropdownMaxHeight,
      }}
      onClick={(event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
      }}
    >
      <div>
        {sG_userType === UserType.DEVELOPER &&
          MenuItem({
            name: 'btnOIDCToken',
            text: i18n.t('View Token'),
            Icon: KeyRound,
            onClick: props.buttonHandler,
          })}
        {MenuItem({
          name: 'btnProfile',
          text: i18n.t('Profile'),
          Icon: UserRound,
          onClick: props.buttonHandler,
        })}
        {MenuItem({
          name: 'btnPreferences',
          text: i18n.t('Preferences'),
          Icon: Settings2,
          onClick: props.buttonHandler,
        })}
        {MenuItem({
          name: 'btnLogout',
          text: i18n.t('Logout'),
          Icon: LogOut,
          onClick: props.buttonHandler,
        })}
      </div>
    </div>
  );
} // UserControlDropdownMenu
